import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";
@Injectable({
  providedIn: "root",
})
export class AdminGuard {
  constructor(public router: Router,
    private authService: AuthService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // console.log('guard');
    const isLoggedIn = this.authService.isUserLoggedIn();
    if (isLoggedIn) {
      if (state.url.includes('/auth/login')) {
        this.router.navigate(['/dashboard'], {  });
        return false;
      } else if (state.url.includes('/dashboard') || state.url.includes('/faqs')) {
        if (!this.authService.isAdmin) {
          this.router.navigate(['/chat'], {  });
        } 
      }
      return true;
    } else {
      this.router.navigate(['/auth/login'], {  });
      return false;
    }
  }
}
